import React, { useState } from 'react'
import PropType from 'prop-types'
import config from 'config'

import RadioGroup from '@cred/react-basic-form-fields/RadioGroup'

import CtaButton from 'components/cta-button'
import { fireGtmEvent } from 'utils/gtm'
import PoweredBy from 'components/powered-by'

import styles from './styles.module.scss'

const radioOptions = [
  { value: 'mortgage', label: 'Purchase a home' },
  { value: 'mortgage-refinance', label: 'Refinance my mortgage' },
]

const MortgageCombinedForm = (props) => {
  const { queryString, widgetContext, metaQuery, ctaText } = props

  const [href, setHref] = useState('')
  const [mortgageOption, setMortgageOption] = useState('')
  const [error, setError] = useState(null)

  const onChange = (value) => {
    setError(null)
    setMortgageOption(value)
    setHref(`${config.credibleRoot}/${value}?${queryString}${metaQuery}`)

    fireGtmEvent('fieldChange', { ...widgetContext, mortgageOption: value })
  }

  const onClick = () => {
    if (!mortgageOption) {
      setError('Select an option above.')
    }

    fireGtmEvent('ctaClick', { ...widgetContext, mortgageOption })
  }

  return (
    <>
      <div className={`mortgage-combined ${styles.selection}`}>
        <p className={`${styles.title} mb-16`}>I’m looking to...</p>
        <RadioGroup
          id="mortgageOption"
          name="mortgageOption"
          className="mb-16"
          inputProps={{
            onChange,
          }}
        >
          {radioOptions.map(({ label, value }) => (
            <option label={label} value={value} key={`radio-${value}`} />
          ))}
        </RadioGroup>
        {error && <p className={`${styles.error} mb-8`}>{error}</p>}
      </div>
      <section className={styles.submit}>
        <CtaButton
          data-testid="cta-button"
          href={href}
          onClick={onClick}
          target="_blank"
          fullWidth
          analytics={{
            data: { text: ctaText, activated: !!mortgageOption },
          }}
        >
          {ctaText}
        </CtaButton>
        <PoweredBy className="mt-8" />
      </section>
    </>
  )
}

MortgageCombinedForm.propTypes = {
  widgetContext: PropType.object.isRequired,
  ctaText: PropType.string.isRequired,
  queryString: PropType.string.isRequired,
  metaQuery: PropType.string,
}

export { MortgageCombinedForm }

export default MortgageCombinedForm
